import { Component, Input } from '@angular/core';
import { Columns as Column, Row } from '@app/components/simple-table/simple-table.component';
import { Employee } from '@app/models/employee/employee.model';
import { AuthService } from '@app/services/auth.service';
import { BaseForm } from '@forms/base.form';
import { Review } from '@models/performance/review.model';
import { Template } from '@models/performance/template.model';

@Component({
    selector: 'app-form-bulk-review-summary',
    templateUrl: './bulk-review-summary.template.html',
    styleUrls: ['./bulk-review-summary.style.scss'],
})
export class BulkReviewSummaryForm extends BaseForm {
    @Input() review: Review;
    @Input() reviewees: Employee[];
    @Input() templates: Template[];
    @Input() set participants(participants: Row[]) {
        if (!participants?.length) {
            return;
        }
        this._participants = participants;
        this.rows = this.participants;
    }

    get participants(): Row[] {
        return this._participants;
    }

    private _participants: Row[] = [];

    columns: Column[] = [
        { columnName: 'performance.summary.revieweesAndParticipants.revieweeLabel', columnSpan: 'columns-4' },
        { columnName: 'performance.summary.revieweesAndParticipants.participantsLabel', columnSpan: 'columns-8' },
    ];
    rows: Row[] = [];

    constructor(private auth: AuthService) {
        super();
    }

    onSearch(searchQuery: string | null): void {
        if (searchQuery === null) {
            this.rows = this.participants;
            return;
        }

        this.rows = this.participants.filter((row) => {
            const employeeCell = row.cells[0] as { employee: Employee; isAvatar: boolean };
            return employeeCell.employee.fullName.toLowerCase().includes(searchQuery.toLocaleLowerCase());
        });
    }

    getTemplateName(id: number): string {
        return this.templates.filter((template) => template.id == id)[0].name;
    }
}
